module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Line-420cdbf0bae5bae628edb2b2b60fdc8aa5770a012e6024b8203864e8dbb1e50a.svg";